import { EnhancedTabs } from 'components/enhanced/tabs/EnhancedTabs';
import { useIsTenantAdministrator } from 'shared/permissions/IsTenantAdministrator';
import TenantPage from 'layouts/TenantPage';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import AccessoryForm from '../components/AccessoryForm';
import ConfirmEquipmentSwitchDialog from '../components/ConfirmEquipmentSwitchDialog';
import { useAccessorEditor } from '../hooks/useAccessorEditor';

export function AccessoryUpdateView() {
  const translationPrefix = 'pages.accessories.edit';
  const { accessorId } = useParams();
  const isDisabledEdit = !useIsTenantAdministrator();

  const { t } = useTranslation();
  const {
    accessor,
    confirmSwitchOpen,
    persistAccessorUpdate,
    handleConfirmSwitch,
    handleCancelSwitch
  } = useAccessorEditor({ accessorId });

  const tabConfig = [
    {
      label: t(`global.base-info`),
      component: (
        <AccessoryForm
          accessor={accessor}
          onSubmit={persistAccessorUpdate}
          isDisabledEdit={isDisabledEdit}
        />
      )
    }
  ];

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}
      entityCode={accessor?.code}>
      <EnhancedTabs
        tabs={tabConfig}
        variant="scrollable"
        documentConfig={{
          serviceName: 'accessor',
          entityId: accessor?.id,
          dictParams: { accessor: accessorId },
          customFolderName: `menu.accessories/${accessor?.code}`,
          folderDescription: `Descrizione: ${accessor?.description}; Seriale: ${accessor?.serial_number}; `,
          disableEdit: isDisabledEdit
        }}
      />
      <ConfirmEquipmentSwitchDialog
        open={confirmSwitchOpen}
        onCancel={handleCancelSwitch}
        onConfirm={handleConfirmSwitch}
      />
    </TenantPage>
  );
}

export default AccessoryUpdateView;
